import { defineStore } from "pinia";

export const useStatusStore = defineStore("status", {
  state: () => ({
    showSuiviModal: false,
  }),
  actions: {
    openSuiviModal() {
      this.showSuiviModal = true;
    },
    closeSuiviModal() {
      this.showSuiviModal = false;
    },
  },
});
